import * as React from "react";
import { toINR } from "../../../../service/numberFormat";

export interface IHoldEqSmallcaseRowMobProps {
	rowData: any;
}

const HoldEqSmallcaseRowMob: React.FC<IHoldEqSmallcaseRowMobProps> = props => {
	return (
		<li className="data_row">
			<div className="row1">
				<div className="col trdSym">
					<span dangerouslySetInnerHTML={{ __html: props.rowData.stockName }}></span>
				</div>
				<div className="col ltp">LTP: {toINR(props.rowData.shares)}</div>
			</div>
			<div className="row2">
				<div className="col totQty">Total Qty: {toINR(props.rowData.ltp)}</div>
				<div className="col totQty">Holding Value: {toINR(props.rowData.averagePrice)}</div>
			</div>
		</li>
	);
};

export default HoldEqSmallcaseRowMob;
